import { Icon, IconProps } from './Icon';

interface LikeIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const LikeIcon = ({ color = '#B9DDFF', gradient, ...props }: LikeIconProps) => (
  <Icon
    {...props}
    viewBox="0 0 29 28"
  >
    {gradient && (
      <defs>
        <linearGradient
          id={gradient.id}
          x1="80%"
          y1="20%"
          x2="20%"
          y2="80%"
        >
          {gradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={stop.offset}
              stopColor={stop.color}
            />
          ))}
        </linearGradient>
      </defs>
    )}
    <path
      d="M15.6328 5.19946C18.2019 2.63036 22.3673 2.63055 24.9365 5.19946C27.5057 7.76865 27.5057 11.934 24.9365 14.5032L14.6367 24.804L14.6279 24.7961L14.5459 24.8791L4.24507 14.5784C1.67618 12.0092 1.67606 7.84376 4.24507 5.27465C6.81417 2.70555 10.9796 2.70573 13.5488 5.27465L14.5527 6.27856L15.6328 5.19946Z"
      fill={gradient ? `url(#${gradient.id})` : color}
    />
  </Icon>
);
